import request from '@/utils/request'

export function getYyjlList(data) {
  return request({
    url: '/api/Extend/LqYyjl',
    method: 'get',
    data
  })
}

/** 门店员工排班一览（含多健康师） */
export function getStoreSchedule(data) {
  return request({
    url: '/api/Extend/LqYyjl/StoreSchedule',
    method: 'get',
    data
  })
}

export function getYyjlInfo(id) {
  return request({
    url: `/api/Extend/LqYyjl/${id}`,
    method: 'get'
  })
}

export function createYyjl(data) {
  return request({
    url: '/api/Extend/LqYyjl',
    method: 'post',
    data
  })
}

export function updateYyjl(id, data) {
  return request({
    url: `/api/Extend/LqYyjl/${id}`,
    method: 'put',
    data
  })
}

export function startYyjlService(id) {
  return request({
    url: `/api/Extend/LqYyjl/${id}/StartService`,
    method: 'post',
    data: {}
  })
}

export function cancelYyjl(id, noDealRemark = '') {
  return request({
    url: `/api/Extend/LqYyjl/${id}/Cancel`,
    method: 'post',
    data: { noDealRemark }
  })
}

export function completeYyjl(id) {
  return request({
    url: `/api/Extend/LqYyjl/${id}/Complete`,
    method: 'post',
    data: {}
  })
}
